// extracted by mini-css-extract-plugin
module.exports = {"body":"NewsItem_body__1njrq","preview":"NewsItem_preview__agJ1o"};